import { Component, OnInit } from '@angular/core';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
    selector: 'app-vehicle-users',
    templateUrl: './vehicle-users.component.html',
    styleUrls: ['./vehicle-users.component.scss'],
    standalone: false
})
export class VehicleUsersComponent implements OnInit {
  Images = IMAGES
  constructor() { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });

  }

}
